export const MARKETS_FETCH = 'markets_fetch'
export const MARKETS_FETCH_SUCCESSFUL = 'markets_fetch_successfull'
export const MARKETS_FETCH_FAILED = 'markets_fetch_failed'
export const UPDATE_FAVORITE = 'UPDATE_FAVORITE'
export const UPDATE_FAVORITE_SUCCESS = 'UPDATE_FAVORITE_SUCCESS'
export const UPDATE_FAVORITE_FAIL = 'UPDATE_FAVORITE_FAIL'
export const PRICING_FETCH = 'pricing_fetch'
export const PRICING_FETCH_SUCCESSFUL = 'pricing_fetch_successful'
export const PRICING_FETCH_FAILED = 'pricing_fetch_failed'
export const MARKETS_FETCH_SPECIFIC = 'MARKETS_FETCH_SPECIFIC'
export const MARKETS_FETCH_SPECIFIC_SUCCESSFUL = 'MARKETS_FETCH_SPECIFIC_SUCCESSFUL'
export const MARKETS_FETCH_SPECIFIC_FAILED = 'MARKETS_FETCH_SPECIFIC_FAILED'
